import type { ReactNode } from 'react';

/**
 * A page with no app shell (docs/design-system.md, "Auth card"): the graticule, the wordmark, and
 * one card. With no `title` it is the bare screen shown while `me` has not answered, which must
 * not look like the app (docs/specs/accounts.md, section 8).
 */
export function AuthCard({
  title,
  account,
  footnote,
  children,
}: {
  title?: string;
  /** The email the card acts on, when it is known: an identifier, so it renders mono. */
  account?: string;
  footnote?: string;
  children: ReactNode;
}): JSX.Element {
  return (
    <main className="auth-page grat">
      <div className="auth-column">
        <div className="auth-brand">
          <span className="wordmark">Market Analysis</span>
          <span className="brand-sub">market survey</span>
        </div>
        {title ? (
          <section className="panel auth-card" aria-labelledby="auth-card-title">
            <header className="auth-head">
              <h1 id="auth-card-title" className="display auth-title">
                {title}
              </h1>
              {account && <span className="auth-account">{account}</span>}
            </header>
            {children}
            {footnote && <p className="auth-footnote muted">{footnote}</p>}
          </section>
        ) : (
          children
        )}
      </div>
    </main>
  );
}
